import type * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'
import * as models from '../models'

/** TODO:  */
export const onAddNodeRelay = store.effects.create(
  (feature: Feature) =>
    feature.actions.addNode.relay((forward, action) => {
      const { chartId, parentId, node } = action

      if (models.Chart.Entry.get(chartId) === 'current') {
        return rxjs.of({
          cancellation: {
            reason: 'Adding nodes is disabled for current chart.',
          },
        })
      }

      return feature.selectors
        .getApplicableModelId({ chartId, parentId })
        .asObservable.pipe(
          rxjs.take(1),
          rxjs.map(modelId => {
            if (!modelId) {
              return {
                cancellation: {
                  reason: `No applicable model found for chartId: '${chartId}' and parentId: '${parentId}'`,
                },
              }
            }

            const nodeRecordToCreate = _getNodeRecordDefaultValues({
              modelId,
              node,
            })

            return forward(feature.actions.saveData, {
              input: {
                chartId,
                modelId,
                record: {
                  parentId,
                  purposes: [],
                  values: nodeRecordToCreate,
                },
              },
              output: () => ({
                node: {
                  label: 'New Node',
                  modelId,
                  values: nodeRecordToCreate,
                },
              }),
            })
          }),
        )
    }).asObservable,
)

/** TODO */
function _getNodeRecordDefaultValues({
  modelId,
  node,
}: {
  modelId: ents.core.dms.models.ForRecord.Id
  node: Partial<ents.core.display.tree.Node>
}): ents.core.dms.data.Record.Values {
  return {
    '!id': '?TODO',
    ...node.values,
    '!active_periods': '{}',
    '!code': 'New Node',
    '!description': '',
    '!name': 'New Node',
  }
}
